import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Stack,
  Button,
  Avatar,
  Menu as MenuComponent,
  MenuItem,
  Box,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { Menu } from "@mui/icons-material";
import { logout } from "../auth/auth";
import { ExitToApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import MosierLogo from "../pages/utils/images/mosier-logo.png";

const Topbar = ({ setShowPopUp, userData }) => {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuHover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogOut = () => {
    logout();
    handleMenuClose();
  };

  return (
    <AppBar position="sticky">
      <Toolbar
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          bgcolor: "white",
          color: "black",
        }}
      >
        <Stack
          direction="row"
          sx={{
            flexGrow: 1,
            marginTop: { xs: "1rem", md: 0 },
            marginBottom: { xs: openMenu ? 0 : "1rem", md: 0 },
          }}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: "100%", sm: "auto" },
              cursor: "pointer",
              marginY: { xs: 0, md: "1rem" },
            }}
            onClick={() => {
              navigate("/");
            }}
          >
            <img
              src={MosierLogo}
              alt="Milk Tub Logo"
              style={{ width: "200px", height: "50px", margin: "0 3rem" }}
            />
          </Box>
          <Menu
            size="large"
            sx={{ display: { xs: "block", sm: "none" }, cursor: "pointer" }}
            onClick={() => setOpenMenu(!openMenu)}
          />
        </Stack>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          spacing={2}
          sx={{
            mt: { xs: 1, sm: 0 },
            display: { xs: openMenu ? "flex" : "none", sm: "flex" },
            width: { xs: "100%", sm: "auto" },
            paddingBottom: { xs: 1, sm: 0 },
            borderRadius: { xs: "4px", sm: 0 },
          }}
        >
          <Button
            sx={{
              color: "#1d4ed8",
              textTransform: "none",
              zoom: { xs: 1, md: 1.2 },
            }}
            onClick={() => {
              navigate("/");
              setOpenMenu(false);
            }}
          >
            New Report
          </Button>
          <Button
            sx={{
              color: "#1d4ed8",
              textTransform: "none",
              zoom: { xs: 1, md: 1.2 },
            }}
            onClick={() => {
              navigate("/reports");
              setOpenMenu(false);
            }}
          >
            Generated Reports
          </Button>
          <Button
            sx={{
              color: "#1d4ed8",
              textTransform: "none",
              zoom: { xs: 1, md: 1.2 },
            }}
            onClick={() => {
              setShowPopUp(true);
              setOpenMenu(false);
            }}
          >
            Customise Report
          </Button>
          <Button
            sx={{
              color: "#1d4ed8",
              textTransform: "none",
              zoom: { xs: 1, md: 1.2 },
              position: "relative",
              cursor: "default",
            }}
          >
            Credits
            <span
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "rgb(255, 0, 0)",
                color: "white",
                borderRadius: "5px",
                minHeight: "1rem",
                minWidth: "1rem",
                fontSize: "0.5rem",
                fontWeight: "900",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {userData?.credits || 0}
            </span>
          </Button>

          <Button
            sx={{ color: "#1d4ed8", textTransform: "none" }}
            onClick={handleMenuOpen}
            onMouseEnter={handleMenuHover}
          >
            <Avatar
              alt={userData?.email.toUpperCase() || "User"}
              src={userData?.picture_image || userData?.email}
              sx={{ width: 40, height: 40, cursor: "pointer" }}
            />
          </Button>
          <MenuComponent
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              onMouseLeave: () => {
                setTimeout(handleMenuClose, 500);
              },
              "aria-labelledby": "basic-button",
            }}
          >
            <Box
              sx={{
                p: 2,
                maxWidth: "200px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                position: "relative",
              }}
              title={userData?.email}
            >
              <Typography variant="body2">Logged in as:</Typography>
              <Typography variant="caption" color="textSecondary">
                {userData?.email}
              </Typography>
            </Box>
            <MenuItem
              onClick={handleLogOut}
              sx={{ display: "flex", justifyContent: "space-between" }}
            >
              Logout
              <ExitToApp />
            </MenuItem>
          </MenuComponent>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

export default Topbar;
